import config from "../config/config";
import { getTokens } from "../utils/commonUtils";

const apiURL = config.API_URL;

const handleResponse = async (response) => {
    if (!response.ok) {
        const errorData = await response.text();
        throw new Error(`Error ${response.status}: ${errorData}`);
    }
    return response;
};

const getAuthHeaders = () => {
    const tokens = getTokens();
    if (!tokens || !tokens.accessToken) {
        throw new Error("Authorization tokens are missing.");
    }
    return { Authorization: `Bearer ${tokens.accessToken}` };
};

export const get = async (endpoint, isAuthRequired = false) => {
    const url = `${apiURL}${endpoint}`;
    // console.log("URL: ", url);
    const headers = { "Content-Type": "application/json", ...(isAuthRequired && getAuthHeaders()) };
    const response = await fetch(url, { method: "GET", headers });
    return handleResponse(response).then((res) => res.json());
};

export const postWithCustomHeaders = async (endpoint, data, customHeaders = {}, isAuthRequired = false) => {
    const url = `${apiURL}${endpoint}`;
    const headers = {
        "Content-Type": "application/json",
        ...(isAuthRequired && getAuthHeaders()),
        ...customHeaders, // Merge custom headers
    };
    const response = await fetch(url, { method: "POST", headers, body: JSON.stringify(data) });
    return handleResponse(response).then((res) => res.json());
};


export const post = async (endpoint, data, isAuthRequired = false) => {
    const url = `${apiURL}${endpoint}`;
    // console.log("URL: ", url);
    const headers = { "Content-Type": "application/json", ...(isAuthRequired && getAuthHeaders()) };
    const response = await fetch(url, { method: "POST", headers, body: JSON.stringify(data) });
    return handleResponse(response).then((res) => res.json());
};

export const postMultipart = async (endpoint, formData, isAuthRequired = false) => {
    const url = `${apiURL}${endpoint}`;
    const headers = isAuthRequired ? getAuthHeaders() : {}; // Do not set "Content-Type"; the browser sets it for multipart
    const response = await fetch(url, { method: "POST", headers, body: formData }); // Pass FormData directly
    return handleResponse(response).then((res) => res.json());
};


export const fetchBlob = async (endpoint, data, isAuthRequired = false) => {
    const url = `${apiURL}${endpoint}`;
    // console.log("URL: ", url);
    const headers = { "Content-Type": "application/json", ...(isAuthRequired && getAuthHeaders()) };
    const response = await fetch(url, { method: "POST", headers, body: JSON.stringify(data) });
    return handleResponse(response).then((res) => res.blob());
};
